// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { getRadio } from 'statsradio/modules/authentication/session/reducers/sessionReducer';
import type { FeaturePermission } from 'common/domain/FeaturePermission';
import Radio from 'common/domain/radio';
import type { Permission } from './Permissions';
import RadioUser from '../../domain/RadioUser';

type Props = {
  permissions?: Permission | Array<Permission>,
  featurePermissions?: FeaturePermission | Array<FeaturePermission>,
  user?: RadioUser,
  radio?: Radio,
  children: any,
  FailureComponent?: any,
  requireAll?: boolean,
};

function hasPermissions(user: RadioUser, permissions: Permission | Array<Permission>, requireAll?: boolean): boolean {
  if (!permissions) {
    return true;
  }

  if (Array.isArray(permissions)) {
    if (permissions.length === 0) {
      return true;
    } else if (requireAll) {
      return permissions.every(permission => user.hasPermission(permission));
    }
    return permissions.some(permission => user.hasPermission(permission));
  }

  return user.hasPermission(permissions);
}

function hasFeaturePermissions(radio: Radio, featurePermissions?: FeaturePermission | Array<FeaturePermission>): boolean {
  if (!featurePermissions) {
    return true;
  }
  if (Array.isArray(featurePermissions)) {
    if (featurePermissions.length === 0) {
      return true;
    }
    return featurePermissions.every(featurePermission => radio.hasFeaturePermission(featurePermission));
  }
  return radio.hasFeaturePermission(featurePermissions);
}

export function AuthorisedComponent({ user, permissions, featurePermissions, FailureComponent, children, requireAll, radio }: Props) {
  if (!user || !radio) {
    return null;
  }

  if (hasPermissions(user, permissions, requireAll) &&
    hasFeaturePermissions(radio, featurePermissions)) {
    return children;
  } else if (FailureComponent) {
    return <FailureComponent />;
  }
  return null;
}

function mapStateToProps(state) {
  return {
    user: state.session.radioUser,
    radio: getRadio(state),
  };
}

export default connect(mapStateToProps)(AuthorisedComponent);



// WEBPACK FOOTER //
// ./src/statsradio/modules/authorisation/AuthorisedComponent.js